export default function basketConditionsModalController(
    $scope,
    $timeout,
    $element,
    close
) {
    $scope.select = function (bool) {
        // IF "use selected" has been choosen - Continue as is (category object is changed when toggled)
        $timeout(function () {
            $scope.modalClose(bool);
        }, 500);
    };

    /**
     * Close Modal (Promise to callback func)
     */
    $scope.modalClose = function (bool) {
        $element.modal("hide");

        close(bool, 500); // close, but give 500ms for bootstrap to animate
    };
}
